import axios from '@/utils/http'

/**
 *
 * 获取策略列表
 * @export
 * @param {*} params
 * @returns
 */
export function getStrategyList(params) {
	return axios({
		url: '/WorkersService/WorkersManage/GetCompanyStrategysListV2',
		method: 'get',
		params: {
			...params
		}
	})
}

/**
 *
 * 添加策略
 * @export
 * @param {*} params
 * @returns
 */
export function addStrategy(params) {
	return axios({
		url: '/WorkersService/WorkersManage/AddCompanyStrategysV2',
		method: 'post',
		data: params
	})
}

/**
 *
 * 修改策略
 * @export
 * @param {*} params
 * @returns
 */
export function editStrategy(params) {
	return axios({
		url: '/WorkersService/WorkersManage/EditCompanyStrategysV2',
		method: 'post',
		data: params
	})
}

/**
 *
 * 删除策略
 * @export
 * @param {*} params
 * @returns
 */
export function delStrategy(params) {
	return axios({
		url: '/WorkersService/WorkersManage/RemoveCompanyStrategysV2',
		method: 'post',
		data: params
	})
}

/**
 *
 * 获取策略详情
 * @export
 * @param {*} params
 * @returns
 */
export function getStrategyDetail(params) {
	return axios({
		url: '/WorkersService/WorkersManage/GetCompanyStrategysDetailV2',
		method: 'get',
		params: {
			...params
		}
	})
}

/**
 *
 * 获取优惠类型
 * @export
 * @param {*} params
 * @returns
 */
export function getDiscountType(params) {
	return axios({
		url: '/WorkersService/WorkersManage/GetDiscountTypeV2',
		method: 'get',
		params: {
			...params
		}
	})
}

/**
 *
 * 获取周期类型
 * @export
 * @param {*} params
 * @returns
 */
export function getCycleType(params) {
	return axios({
		url: '/WorkersService/WorkersManage/GetPeriodTypeV2',
		method: 'get',
		params: {
			...params
		}
	})
}
